module.exports = __webpack_public_path__ + "static/img/default_img_no_data.e2a77a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/dataEffect/accountData/default_img_no_data.png
// module id = tzip
// module chunks = 1